import axios from 'axios';
import { DEFAULTORIGIN, TIMEOUT } from './constant';
import { _message } from '../components/message';

export const HTTPTYPE = {
    'formurlencoded': 'application/x-www-form-urlencoded',
    'JSON': 'application/json',
}

const API = axios.create({
    baseURL: DEFAULTORIGIN,
    timeout: TIMEOUT,
    headers: {
        'Content-Type' : HTTPTYPE.formurlencoded
    }
});

API.interceptors.request.use(config => config, error => Promise.reject(error));
   
API.interceptors.response.use(response => {
    return response.data;
}, error => {
    return Promise.reject(new Error(error?.response?.data?.msg || error?.response?.data?.message || error?.message || '网络请求失败'));
});

export const PostData = (url: string, data={}, config={}) => API.request<any, any>({
    url: url,
    method: 'POST',
    data,
    ...config
});
   
export const GetData = (url: string, data={}, config={}) => API.request<any, any>({
    url: url,
    method: 'GET',
    params: data,
    ...config
});

export const PutData = (url: string, data={}, config={}) => API.request<any, any>({
    url,
    method: 'PUT',
    data,
    ...config
});

export const DeleteData = (url: string, data={}, config={}) => API.request<any, any>({
    url,
    method: 'DELETE',
    params: data,
    ...config
});

export const PatchData = (url: string, data={}, config={}) => API.request<any, any>({
    url,
    method: 'PATCH',
    params: data,
    ...config
});

export default { PostData, GetData, PutData, DeleteData, PatchData };
